import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const selectMenuProps = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  getContentAnchorEl: null,
};

const FlowBuilderTicketModal = ({ open, onSave, data, onUpdate, close }) => {
  const m = useAerosModalStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [queues, setQueues] = useState([]);
  const [selectedQueue, setQueueSelected] = useState();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  useEffect(() => {
    if (open === "edit") {
      (async () => {
        try {
          const queue = data.data.queue;
          const user = data.data.user;

          const { data: old } = await api.get("/queue");
          const { data: result } = await api.get("/users");

          setUsers(result.users);
          setQueues(old);

          setQueueSelected(queue.id);
          setSelectedUser(user.id);

          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          const { data } = await api.get("/queue");
          const { data: result } = await api.get("/users");
          setUsers(result.users);
          setQueues(data);
          setSelectedUser("");
          setQueueSelected("");
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = () => {
    if (!selectedQueue) {
      return toast.error(i18n.t("aeros.flow.modals.ticket.errorQueue"));
    }
    const queue = queues.find((item) => item.id === selectedQueue);
    const user = users.find((item) => item.id === selectedUser);
    if (open === "edit") {
      onUpdate({
        ...data,
        data: {
          queue: queue ? queue : "",
          user: user ? user : "",
        },
      });
    } else if (open === "create") {
      onSave({
        queue: queue ? queue : "",
        user: user ? user : "",
      });
    }
    handleClose();
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={480}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.ticket.editTitle" : "aeros.flow.modals.ticket.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
    >
      <div>
        <label className={m.fieldLabel} htmlFor="flow-ticket-queue">
          {i18n.t("aeros.flow.modals.ticket.queue")}
        </label>
        <TextField
          id="flow-ticket-queue"
          select
          className={m.input}
          variant="outlined"
          value={selectedQueue ?? ""}
          onChange={(e) => setQueueSelected(e.target.value)}
          SelectProps={{
            displayEmpty: true,
            MenuProps: selectMenuProps,
            renderValue: (v) => {
              const queue = queues.find((q) => q.id === v);
              return queue ? queue.name : i18n.t("aeros.flow.modals.ticket.queuePlaceholder");
            },
          }}
        >
          {queues.map((queue) => (
            <MenuItem dense key={queue.id} value={queue.id}>
              {queue.name}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderTicketModal;
